
import React, { useEffect, useState } from "react";
import {Tab, Tabs } from 'react-bootstrap';  
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";
import AdminDashboard from "./admindashboard";
import Agentinsurance from "./Agentinsurance";
import EmployeeProfile from "./employeeProfile";
import EmpAppointments from "./empAppointments";
import ViewAppointmentsByEmployer from "./viewAppointmentsByEmployer";
import EmployeeFamilyDetails from "./employeeFamilyDetails";
import EmployeeDoctorAppointment from "./employeeDoctorAppointment";
  function EmployeeProfileTab() {

  const [activeTab, setActiveTab] = useState('employee-profile');
  // const [selectedOrgcode, setSelectedOrgcode] = useState(orgcode);

  useEffect(() => {
  
  }, []);


  return (
    <div>
      <AdminDashboard />
      <br/>
              <br/>
              <br/>
      <br />


<div className="col-12 mx-xl-auto ps-xl-10">
        <div className="card card-raised">
          <div className="card-body">
            <Tabs
              id="employee-profile-tabs"
              activeKey={activeTab}
              onSelect={(tab) => setActiveTab(tab)}
              className="mb-3"
            >
              <Tab eventKey="employee-profile" title="Employee Profile">
              {activeTab === 'employee-profile' && (
                <EmployeeProfile/>
              )}
              </Tab>
              <Tab eventKey="lab-appointments" title="Lab Appointments">
          {activeTab === "lab-appointments" && (
            JSON.parse(localStorage.getItem("data")).role === 'ROLE_EMPLOYER' ? (
              <ViewAppointmentsByEmployer />
            ) : (
              <EmpAppointments />
            )
          )}
          </Tab>

          
          <Tab eventKey="doctor-appointments" title="Doctor Appointments">
      {activeTab === "doctor-appointments" && (
            <EmployeeDoctorAppointment/>
          )}
          </Tab>

          <Tab eventKey="familyDetails" title="Family Details">
      {activeTab === "familyDetails" && (
            <EmployeeFamilyDetails/>
          )}
          </Tab>

          <Tab eventKey="insurance" title="Insurance">
          {activeTab === "insurance" && (
            <Agentinsurance  />
          )}
          </Tab>

            </Tabs>
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default EmployeeProfileTab;